const selector = {
    form: '#payment_form',
    token: '#token',
    clientSecret: '#client_secret',
    cardElement: 'card_element',
    cardErrors: '#card_errors',
    address: '#cardholder_address',
    fullName: '#cardholder_fullname',
    city: '#cardholder_city',
    phone: '#cardholder_phone',
    country: '#country',
    email: '#cardholder_email',
    orderNumber: '#order_number',
    currency: '#currency',
    amount: '#amount'
};

export {selector};
